import { Socket } from "socket.io-client";

/**
 * Captures URL parameters and emits them as an event
 * @param emitEvent Function to emit an event with data
 */
export function captureUrlParameters(
  emitEventCallback: (eventName: string, data: any) => void
): void {
  try {
    // Get URL search params
    const urlParams = new URLSearchParams(window.location.search);
    const paramObject: Record<string, string> = {};

    // Convert URLSearchParams to a plain object
    urlParams.forEach((value, key) => {
      paramObject[key] = value;
    });

    // Only send if there are parameters
    if (Object.keys(paramObject).length > 0) {
      emitEventCallback("page_load_params", {
        params: paramObject,
        fullUrl: window.location.href,
        path: window.location.pathname,
      });
    }
  } catch (error) {
    console.error(
      "MonitoringService: Failed to capture URL parameters:",
      error
    );
  }
}
